import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Bed, Ruler } from "lucide-react";
import { propertyPath } from "@/lib/seo";

/**
 * Compact card used in the split-view map catalog left column.
 * Optimized for smaller widths, hover-triggers pin highlight on the map.
 */
export default function MapListCard({ property, isActive, onHover, onLeave }) {
    const p = property;
    const [imgError, setImgError] = useState(false);
    const cover = (p.photos && p.photos[0]) || null;
    const showImage = cover && !imgError;
    const fmtPrice = (v) => {
        if (v == null) return "—";
        if (v >= 1_000_000) return `€ ${(v / 1_000_000).toFixed(v % 1_000_000 === 0 ? 0 : 2)}M`;
        if (v >= 1000) return `€ ${Math.round(v / 1000)}k`;
        return `€ ${Math.round(v)}`;
    };
    const city = (p.city || "").replace(/\b\w/g, (c) => c.toUpperCase());
    return (
        <Link
            to={propertyPath(p)}
            data-testid={`map-list-card-${p.id}`}
            onMouseEnter={() => onHover && onHover(p.id)}
            onMouseLeave={() => onLeave && onLeave()}
            className={`group flex gap-4 p-3 border transition-all ${
                isActive
                    ? "border-gold bg-gold/5"
                    : "border-white/10 hover:border-gold/60 hover:bg-white/[0.02]"
            }`}
        >
            <div className="relative w-28 h-24 flex-shrink-0 bg-ink-900 overflow-hidden">
                {showImage ? (
                    <img
                        src={cover}
                        alt={p.title || ""}
                        loading="lazy"
                        decoding="async"
                        onError={() => setImgError(true)}
                        className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-500"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-ink-400 text-[10px] uppercase tracking-widest">Nessuna foto</div>
                )}
                {p.transaction_type === "affitto" && (
                    <span className="absolute top-1 left-1 bg-black/70 text-gold-soft text-[9px] uppercase tracking-widest px-1.5 py-0.5">Affitto</span>
                )}
            </div>
            <div className="flex-1 min-w-0">
                <div className="font-serif text-lg text-price leading-tight mb-1">
                    {fmtPrice(p.price)}{p.transaction_type === "affitto" ? <span className="text-xs text-ink-400">/mese</span> : null}
                </div>
                <div className="text-sm text-ink-50 leading-snug line-clamp-2 mb-2">{p.title}</div>
                <div className="flex items-center gap-3 text-[11px] text-ink-400">
                    <span className="flex items-center gap-1"><MapPin size={11} className="text-gold/70" />{city}</span>
                    {p.rooms ? <span className="flex items-center gap-1"><Bed size={11} className="text-gold/70" />{p.rooms}</span> : null}
                    {p.surface_sqm ? <span className="flex items-center gap-1"><Ruler size={11} className="text-gold/70" />{p.surface_sqm} m²</span> : null}
                </div>
            </div>
        </Link>
    );
}
